const article = {
    slug: "maison-margiela",
    category: "BRAND BUYBACK",
    listTitle: "Maison Margiela買取",
    listDescription:
      "本人期・アーティザナル・定番名作まで、Maison Margielaの文脈と市場価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "メゾンマルジェラ買取｜本人期・アーティザナルまで査定するEnclopedia",
      description:
        "メゾンマルジェラの買取ならEnclopediaへ。Maison Margiela、旧Maison Martin Margiela、本人期、アーティザナル、八の字ライダース、Tabi、5ACなどを、シーズン背景・希少性・市場価値まで見て査定します。",
      keyword:
        "メゾンマルジェラ 買取,マルジェラ 買取,Maison Margiela 買取,Maison Martin Margiela 買取,マルタンマルジェラ 買取,メゾンマルジェラ 高価買取,マルジェラ 宅配買取,マルジェラ 本人期 買取,マルジェラ アーティザナル 買取,八の字ライダース 買取,Tabi 買取,5AC 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/maison-margiela",
    },
    hero: {
      label: "MAISON MARGIELA BUYBACK",
      number: "03 / BUYBACK",
      titleLines: [
        "メゾンマルジェラ買取。",
        "本人期から現行まで、価値を見て査定します。",
      ],
      body:
        "Enclopediaは、Maison Margielaをブランド名だけで一律に判断しません。\n旧Maison Martin Margiela期、本人期、アーティザナル、定番名作、近年の人気モデルまで、それぞれの文脈と市場価値を確認して査定します。\nまずはLINEで事前にご相談いただき、納得感のある宅配買取へつなげます。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "buyback",
        "archive valuation",
        "artisanal",
        "maison margiela",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "流行価格ではなく、",
        "その服の背景まで見る。",
      ],
      image: "media/archive_fashion/buyback3.png",
      imageAlt: "Maison Margiela買取のメイン画像",
    },
    thesis: {
      text:
        "Maison Margielaの価値は、定番人気だけでなく、制作年代・ライン・思想・希少性まで見て判断する。",
      keywords: ["period", "line", "rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "マルジェラの価値は、",
        "“有名な定番”だけでは決まらない。",
      ],
      body:
        "Maison Margielaは、解体、再構築、匿名性、既製服の転用といった視点から、ファッションの見方を変えてきたブランドです。\nTabiや5ACのような広く知られた名作がある一方で、旧Maison Martin Margiela期の衣服、本人期のアーカイブ、アーティザナル作品、各ラインの文脈を持つピースには、別の評価軸があります。\nEnclopediaでは、商品名だけではなく、そのアイテムがマルジェラの歴史の中でどの位置にあるかまで確認します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "年代・ディレクションを見る",
          text:
            "旧Maison Martin Margiela期、本人期、デザインチーム期、近年のMaison Margielaまで、制作年代と背景を踏まえて判断します。",
        },
        {
          number: "02",
          title: "ラインとアイテムの意味を見る",
          text:
            "0・1・4・6・10・14・22などのライン、アーティザナル、REPLICA、定番名作など、どの文脈で評価されるかを確認します。",
        },
        {
          number: "03",
          title: "現在の需要と希少性を見る",
          text:
            "八の字ライダース、Tabi、5AC、グラムスラムなどの定番需要に加え、流通量の少ないアーカイブや希少品も個別に見ます。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "Maison Margiela全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "旧Maison Martin Margiela",
          text:
            "マルタン本人期を含む旧名称時代の衣服・靴・バッグ・アクセサリーを丁寧に査定します。",
        },
        {
          tag: "ITEM 02",
          title: "本人期アーカイブ",
          text:
            "過去シーズンの象徴的なジャケット、コート、ニット、パンツ、再構築的なデザインなどを個別に見ます。",
        },
        {
          tag: "ITEM 03",
          title: "Artisanal / アーティザナル",
          text:
            "手仕事や再構成の価値が強く表れるアーティザナル作品は、一般的な型番査定に寄せず個別評価します。",
        },
        {
          tag: "ITEM 04",
          title: "八の字ライダース",
          text:
            "マルジェラを代表する定番名作。年代・素材・サイズ・状態を確認して査定します。",
        },
        {
          tag: "ITEM 05",
          title: "Tabi シューズ",
          text:
            "ブーツ、パンプス、バレエ、ローファーなど、ブランドを象徴するTabiラインを幅広く見ます。",
        },
        {
          tag: "ITEM 06",
          title: "5AC・グラムスラム・バッグ",
          text:
            "現在も需要の高いバッグ類は、型・サイズ・素材・状態を踏まえて査定します。",
        },
        {
          tag: "ITEM 07",
          title: "REPLICA・スニーカー",
          text:
            "ジャーマントレーナーを含むREPLICAシリーズやシューズ類もご相談いただけます。",
        },
        {
          tag: "ITEM 08",
          title: "MM6 Maison Margiela",
          text:
            "MM6についても、アイテム内容や需要に応じて査定対象として確認します。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "Maison Margielaのアイテム。",
      ],
      intro:
        "査定額は状態や相場で変動しますが、Enclopediaでは特に以下のようなマルジェラを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "本人期・旧Maison Martin Margiela期のアーカイブ",
          text:
            "現在では入手しにくい年代の作品や、ブランド史において重要性のあるピースは、一般的な古着評価ではなくアーカイブ価値まで見ます。",
        },
        {
          index: "02",
          title: "アーティザナル・再構築性の強い作品",
          text:
            "既製服の転用、再縫製、匿名性といったマルジェラらしい思想が明確に表れる作品は、流通性だけでなく文脈を確認します。",
        },
        {
          index: "03",
          title: "八の字ライダース・Tabi・5ACなどの定番名作",
          text:
            "広く需要があり、買取検索でも頻繁に対象となる名作は、状態・仕様・年代によって適切に査定します。",
        },
        {
          index: "04",
          title: "状態良好な希少サイズ・人気モデル",
          text:
            "人気サイズ、付属品完備、流通量の少ない仕様は、再販市場での需要を踏まえて評価します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“マルジェラだから高い”ではなく、",
        "なぜ評価されるのかまで見て査定する。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいマルジェラの価値。",
      ],
      intro:
        "Maison Margielaは、同じブランド名でも、年代・ライン・制作背景によって評価軸が大きく変わるブランドです。",
      items: [
        {
          index: "01",
          title: "旧名称期と現行品を一括で見ない",
          text:
            "Maison Martin Margiela期や本人期のアーカイブは、現行品とは異なる需要と評価軸があります。年代を確認して判断します。",
        },
        {
          index: "02",
          title: "ライン番号や作品背景を無視しない",
          text:
            "ラインごとに役割が異なるため、単なるカテゴリ分類ではなく、その服がどの位置づけにあるかを見ます。",
        },
        {
          index: "03",
          title: "定番人気とアーカイブ価値を分けて考える",
          text:
            "Tabiや5ACは市場需要が強い定番として、本人期やアーティザナルは文化的・希少性のあるアーカイブとして、それぞれ異なる角度で査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。宅配買取へ進む前に、おおまかな査定可否をご案内します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいマルジェラ買取。",
      ],
      intro:
        "LINEで相談してから進められるため、買取成立までの不安と手間を減らせます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、無駄な発送や手間を減らせます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "Maison Margiela買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question: "どのMaison Margielaアイテムを買取していますか？",
          answer:
            "ジャケット、コート、ニット、パンツ、シャツ、靴、バッグ、アクセサリーなど幅広くご相談いただけます。",
        },
        {
          question: "Maison Martin Margiela期や本人期も査定できますか？",
          answer:
            "はい。旧名称期、本人期、アーカイブ品は特に年代や作品背景を確認して個別に査定します。",
        },
        {
          question: "アーティザナル作品も買取対象ですか？",
          answer:
            "はい。作品内容・状態・希少性を見て個別に判断します。写真付きのLINE事前査定がおすすめです。",
        },
        {
          question: "八の字ライダースやTabiも査定できますか？",
          answer:
            "はい。八の字ライダース、Tabiブーツ、Tabiパンプス、Tabiバレエなど、代表的な定番品も査定対象です。",
        },
        {
          question: "5ACやグラムスラムなどバッグも買取できますか？",
          answer:
            "はい。Maison Margielaのバッグ類も、型・サイズ・素材・状態を確認して査定します。",
        },
        {
          question: "MM6 Maison Margielaも査定できますか？",
          answer:
            "アイテム内容に応じて査定可能です。まずはLINEで写真をお送りください。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "Maison Margielaの価値をご相談ください。",
      ],
      body:
        "本人期、アーティザナル、定番名作まで確認。\nEnclopediaが、その一着の背景と再流通価値を丁寧に見ます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
